export default class Config
{
    public directory: string = './img';
    public filenames: string = '%04d.png';
    public range: Array<number> = [ 1, 10];
    public delay: number  = 40;
    public replayDelay: number = 5000;
    public bounce: boolean = false;

    static fromImage(image: HTMLImageElement): Config {
        const config = new Config({});

        const data = {};

        for (let attr of image.getAttributeNames()) {
            if (attr.length > 5 && 'data-' === attr.substr(0, 5)) {
                const name = attr.substr(5);
                const type = typeof config[name];

                if ('undefined' !== type) {
                    switch (type) {
                        case 'boolean':
                            data[name] = true;
                            break;
                        case 'object':
                            data[name] = image.getAttribute('data-' + name).split('-').map(entry => parseInt(entry));
                            break;
                        default:
                            data[name] = image.getAttribute('data-' + name)
                    }
                }
            }
        }

        return config.setData(data)
    }

    constructor(config: Object) {
        if (Object.keys(config).length > 0) {
            this.setData(config);
        }
    }

    setData(config: Object): Config {
        for (let key in config) {
            if ('undefined' !== typeof this[key]) {
                this[key] = config[key];
            }
        }

        return this;
    }
}
